//
// Module for Employer Schedules Reporting Schedule Detail view
//
rs.module("content/employer/reporting/schedules/reportingScheduleDetail",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, ajaxUrls) {
            var reportingScheduleForm = $.js(jsSelectors.reportingScheduleForm);

            var fiscalYearInput = reportingScheduleForm.js(jsSelectors.fiscalYearInput);
            var voucherNumberSelect = reportingScheduleForm.js(jsSelectors.voucherNumberSelect);
            var voucherSelectHelper = selectHelper.getHelper(voucherNumberSelect);

            // Re-populate voucher drop down options
            fiscalYearInput.change(PopulateVoucherSelect);

            // Populate the voucher number drop down options
            function PopulateVoucherSelect() {
                var fiscalYear = fiscalYearInput.val();

                if (fiscalYearInput.valid()) {
                    voucherSelectHelper.loadOptionsFrom(
                        ajaxUrls.populateVouchersUrl,
                        { fiscalYear: fiscalYear },
                        { withBlank: true });
                } else {
                    voucherSelectHelper.clearOptions();
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);